import { Grid, Typography } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendGetRequest,
  sendPostRequest,
  sendPatchRequest,
  removeEmpty,
  allowedOperations
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";
import {
  Dropzone, FileMosaic, FullScreen,
  ImagePreview,
  VideoPreview
} from "@files-ui/react";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Autocomplete,
  TextField,
  Chip,
  Checkbox
} from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const ageGroup = [
  { range: "0-9", name: "Early child hood (AK,NN)" },
  { range: "7-14", name: "Primary (UK,NN)" },
  { range: "18-100", name: "Caregivers" },
]

export const getAgeRanges = (start, end) => {
  const ranges = ageGroup.map(group => {
    const parts = group.range.split("-");
    return { start: +parts[0], end: +parts[1] }
  });
  return ranges.filter(range => range.start >= start && range.end <= end).map(range => `${range.start}-${range.end}`);
}

export const getSingleRange = (values = null) => {
  const parts = (values || []).map(range => range.split("-")).flat(1);
  return `${Math.min(...parts)}-${Math.max(...parts)}`
}

const _ref = {
  uuid: "",
  thumbnail: "",
  url: "",
  title: "",
  languages: [],
  fromAge: null,
  toAge: null,
  premium: [],
  source: "s3",
};


export const GameEdit = () => {
  const { uuid } = getParams();
  var [game, setGame] = useState(_ref);
  var [files, setFiles] = useState([]);
  const [continents, setContinents] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [imageSrc, setImageSrc] = useState(undefined);
  const [videoSrc, setVideoSrc] = useState(undefined);
  const [ageRange, setAgeRange] = useState([]);
  var [thumbError, setThumbError] = useState(false);
  const { canCreate } = allowedOperations();

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });

  const updateFiles = (selectedFiles) => {
    const images = [];
    selectedFiles.forEach(file => {
      if (file.type.startsWith("image")) images.push(file);
    });

    if (images.length === 1) {
      setFiles(selectedFiles);
    }
  };

  const onDelete = (id) => {
    setFiles(files.filter((_file) => _file.id !== id));
  };

  const handleSee = (imageSource) => {
    setImageSrc(imageSource);
  };
  const handleWatch = (videoSource) => {
    setVideoSrc(videoSource);
  };

  const getMimeType = () => {
    try {
      const mimeTypes = ["image/*"]
      return mimeTypes;
    } catch (e) {
      return [];
    }
  }

  useEffect(() => {
    setStatus({ ...{ loading: true } })
    Promise.all([
      sendGetRequest(`contents/continents`),
      sendGetRequest(`languages`),
      uuid ? sendGetRequest(`games?uuid=${uuid}`): null
    ]).then(([continents, languages, game]) => {
      setContinents(continents);
      setLanguages(languages);
      if(game){
        const ranges = getAgeRanges(game.fromAge, game.toAge);
        setAgeRange(ranges);
        const langs = languages.filter(lan => game.languages.includes(lan.isoCode)).map(lan => lan.name);
        game.languages = langs;
        setGame(game);
      }
      setStatus({ ...{ loading: false } })
    });
    return () => setGame(_ref);
    // eslint-disable-next-line
  }, [uuid]);

  
  const getGame = () => {
    delete game.uuid;

    if (game.source === "file") {
      delete game.thumbnail;
    }

    if (game.languages.length){
      game.languages = languages.filter(lan => game.languages.includes(lan.name)).map(lan => lan.isoCode);
    }

    if (!game.premium.length || !game.premium) delete game.premium;

    const formData = new FormData();
    const _game = removeEmpty(game);
    for (const [key, value] of Object.entries({ ..._game })) {
      formData.append(key, ((key === "premium" && value.length) || key === "languages") ? JSON.stringify(value) : value);
    }

    if (uuid) game.uuid = uuid;

    if (files.length) {
      files.forEach(file => {
        formData.append('files', file.file)
      })
    }
    return {
      form: formData, game
    };
  }

  const createUpdate = () => {

    if (!uuid) {
      sendPostRequest('games', getGame().form,
        (loading) => setStatus({ ...{ loading: loading } }), (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        });
    } else {
      sendPatchRequest(`games/${uuid}`, getGame().game,
        (loading) => setStatus({ ...{ loading: loading } }), (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        });
    }
  };



  const showUrlOps = () => game.source === "s3";

  const onValueChange = (value, tag) => {
    setGame({ ...game, [tag]: value });

    const error = !(`${value}`.startsWith("s3://") && `${value}`.includes(".") && `${value}`.split(".").length >= 2);
    if (tag === "thumbnail") setThumbError(error);
  };

  const isValidUrl = (url, s3 = true) => {
    if (`${url}`.length){
      if (s3) return (`${url}`.startsWith("s3://") && `${url}`.includes(".") && `${url}`.split(".").length >= 2);
      return (`${url}`.startsWith("https://") && `${url}`.includes(".") && `${url}`.split(".").length >= 2);
    }
    return true;
  }


  const checkPropsValidity = () => {
    let basic = game.title !== null && game.languages !== null && game.url !== null && 
      game.fromAge !== null && (+`${game.fromAge}`) >= 0 && game.toAge !== null && +(`${game.toAge}`) <= 100;

    basic = basic && ((+`${game.fromAge}`) < (+`${game.toAge}`));

    const isS3Validsource = uuid ? true: (game.source === "s3" && files.length === 0)
      && game.thumbnail !== null && isValidUrl(game.thumbnail);

    const isFileValidSource = uuid ? true:  files.length && game.source !== "s3";

    basic = basic && (isS3Validsource || isFileValidSource);

    return basic;
  }


  return (
    <EditPage
      title={uuid ? `Edit game` : `Add game`}
      status={status}
      btnLabel={canCreate ? (uuid ? "Update Now" : "Add Now"): null}
      onSave={() => createUpdate()}
      spacing={5}
      onBack={() => navigate(`${AppRoutes.games}`, true)}
      validated={checkPropsValidity() && !status.loading }
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setGame({ ..._ref });
          navigate(`${AppRoutes.games}`, true);
        }
      }}
    >
      <Grid item md={3} xs={12}>
        <FormControl sx={{ minWidth: 50 }} fullWidth>
          <InputLabel id="game-source">Thumbnail Source</InputLabel>
          <Select
            value={game.source || "s3"}
            label="Thumbnail Source"
            labelId="game-source"
            id="source"
            disabled={status.loading}
            onChange={(e) => onValueChange(e.target.value, "source")}
          >
            {[
              { name: "S3 URLS", value: "s3" },
              { name: "File Upload", value: "file" },
            ].map((souces) => {
              return (
                <MenuItem value={souces.value} id={souces.value}>
                  &nbsp;&nbsp;&nbsp;{souces.name}
                  <br />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item md={(showUrlOps() || uuid != null) ? 9: 4} xs={12}>
        <EasyTextEdit
          label="Game title"
          placeholder="Descriptive tile of this game"
          type="text"
          id="title"
          errorText=""
          textField={true}
          disabled={status.loading}
          value={game.title}
          onChange={onValueChange}
        />
      </Grid>


      {(showUrlOps() || uuid != null) && (
        <Grid item md={6} xs={12}>
          <EasyTextEdit
            placeholder="S3 file URI i.e s3://bucket-id/folder/directory/image.jpg"
            label="Game thumbnail image"
            type="text"
            textField={true}
            error={thumbError}
            id="thumbnail"
            errorText={
              thumbError ? "Make sure you fill in AWS s3 file URI" : ""
            }
            disabled={status.loading}
            value={game.thumbnail}
            onChange={onValueChange}
          />
        </Grid>
      )}

      <Grid item md={showUrlOps() ? 6 : 5} xs={12}>
        <EasyTextEdit
          placeholder="Game public URL"
          label="Actual game URL"
          type="text"
          textField={true}
          error={!isValidUrl(game.url, false)}
          id="url"
          errorText={!isValidUrl(game.url, false) ? "Make sure you fill in public URL" : ""}
          disabled={status.loading}
          value={game.url}
          onChange={onValueChange}
        />
      </Grid>

      {game.source === "file" && getMimeType().length && (
        <Grid item md={12} xs={12}>
          <Dropzone
            onChange={updateFiles}
            value={files}
            minHeight="195px"
            maxFiles={1}
            accept={getMimeType().join(",")}
            maxFileSize={1024 * 1024 * 10}
            label="Drag'n drop game thumbnail or click to browse"
          >
            {files.map((file) => (
              <FileMosaic
                {...file}
                resultOnTooltip
                alwaysActive
                preview
                info
                onDelete={onDelete}
                onSee={handleSee}
                onWatch={handleWatch}
              />
            ))}
          </Dropzone>

          <FullScreen
            open={imageSrc !== undefined}
            onClose={() => setImageSrc(undefined)}
          >
            <ImagePreview src={imageSrc} />
          </FullScreen>
          <FullScreen
            open={videoSrc !== undefined}
            onClose={() => setVideoSrc(undefined)}
          >
            <VideoPreview src={videoSrc} autoPlay controls />
          </FullScreen>
        </Grid>
      )}

      <Grid item md={12}>
        <Typography variant="h6" component="h2">
          Langauges, Audiance and Paywall
        </Typography>
      </Grid>


      <Grid item md={4} xs={12}>
        <Autocomplete
          multiple={true}
          id="language"
          disableCloseOnSelect
          limitTags={2}
          disabled={status.loading}
          value={game.languages}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="filled" label={option} {...getTagProps({ index })} />
            ))
          }
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          )}
          options={languages.map((option) => option.name)}
          renderInput={(params) => (
            <TextField {...params} label="Target Languages" />
          )}
          onChange={(event, value) => {
            setGame({ ...game, languages: value})
          }}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Autocomplete
          multiple={true}
          id="age-group"
          disableCloseOnSelect
          limitTags={2}
          disabled={status.loading}
          value={ageRange}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="filled" label={ageGroup.filter(group => group.range === option)[0].name} {...getTagProps({ index })} />
            ))
          }
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {ageGroup.filter(group => group.range === option)[0].name}
            </li>
          )}
          options={ageGroup.map((option) => option.range)}
          renderInput={(params) => (
            <TextField {...params} label="Target audiance" />
          )}
          onChange={(event, value) => {
            setAgeRange(value);
            const ranges = value.length ? getSingleRange(value).split('-') : [null, null];
            setGame({ ...game, fromAge: ranges[0], toAge: ranges[1] })
          }}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Autocomplete
          multiple
          id="premium"
          disableCloseOnSelect
          disabled={status.loading}
          limitTags={2}
          value={game.premium && Array.isArray(game.premium) ? game.premium.map(pre => pre.name) : []}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          )}
          options={continents.map((option) => option.name)}
          renderInput={(params) => (
            <TextField {...params} label="Premium Game Locations" />
          )}
          onChange={(event, value) => {
            const values = continents
              .filter(cont => value.includes(cont.name))
            onValueChange(values, "premium");
          }}
        />
      </Grid>
    </EditPage>
  );
};
